"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _clsx2 = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _Contents = _interopRequireDefault(require("./Contents"));

var _useStyles = _interopRequireDefault(require("./useStyles"));

var _excluded = ["image", "children", "name", "onClick", "selected", "title", "variant"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DEFAULT_VARIANT = "story";

function ListItem(_ref) {
  var image = _ref.image,
      children = _ref.children,
      name = _ref.name,
      onClick = _ref.onClick,
      selected = _ref.selected,
      title = _ref.title,
      variantProp = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded);

  var variant = variantProp || DEFAULT_VARIANT;
  var classes = (0, _useStyles["default"])(_objectSpread(_objectSpread({}, props), {}, {
    image: image,
    onClick: onClick,
    variant: variant
  }));
  var theme = (0, _core.useTheme)();
  var isDesktop = (0, _core.useMediaQuery)(theme.breakpoints.up("md"));
  var isMobile = !isDesktop;
  var isProfile = variant === "profile";
  var buttonProps = onClick ? {
    role: "button",
    tabIndex: 0,
    onClick: onClick,
    onKeyUp: undefined
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, _extends({
    container: true
  }, buttonProps, {
    className: classes.root
  }), isMobile && isProfile && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 6,
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_Contents["default"], _extends({
    name: name,
    selected: selected,
    title: title,
    variant: variant
  }, props), children)), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: isMobile && isProfile ? 6 : 12,
    container: true,
    className: classes.contentsRoot
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: image.description || name || title,
    src: image.url,
    className: (0, _clsx2["default"])(classes.picture, _defineProperty({}, classes.pictureSelected, selected))
  }), (!isProfile || isDesktop) && /*#__PURE__*/_react["default"].createElement(_Contents["default"], _extends({
    name: name,
    selected: selected,
    title: title,
    variant: variant
  }, props), children)));
}

ListItem.propTypes = {
  children: _propTypes.PropTypes.node,
  description: _propTypes.PropTypes.string,
  image: _propTypes.PropTypes.shape({
    description: _propTypes.PropTypes.string,
    url: _propTypes.PropTypes.string.isRequired
  }).isRequired,
  href: _propTypes.PropTypes.string,
  link: _propTypes.PropTypes.shape({
    url: _propTypes.PropTypes.string.isRequired,
    title: _propTypes.PropTypes.string
  }),
  linkComponent: _propTypes.PropTypes.elementType,
  name: _propTypes.PropTypes.string,
  onClick: _propTypes.PropTypes.func,
  selected: _propTypes.PropTypes.bool,
  title: _propTypes.PropTypes.string,
  variant: _propTypes.PropTypes.oneOf(["profile", "story"])
};
ListItem.defaultProps = {
  description: undefined,
  href: undefined,
  link: undefined,
  children: undefined,
  linkComponent: undefined,
  name: undefined,
  onClick: undefined,
  selected: false,
  title: undefined,
  variant: DEFAULT_VARIANT
};
var _default = ListItem;
exports["default"] = _default;